import './index.erb';
import './index.rb';

(function ($) {
  const $cta = $('#playgroundCta');

  $cta.on('click', () => {
    UserTracker.emit('event', {
      eventName: 'mesa button clicked',
      data: {
        portal_source: 'banner'
      }
    });
  });
})(jQuery);
